import * as React from 'react'

import { parseRouteInitData } from '../../main/util'
import { round } from '../backtest/utils'
import BarChart, { Bar } from './barChart'

function convertData(endYear: number, values: any[]) {
  return values.map((value, index) => ({ name: endYear - index, value })).reverse() as unknown as Bar[]
}

interface FAChartProps {
  year: number
  data: number[]
  title: string
  smallRoundPlaces?: number
  largeRoundPlaces?: number
  smallScale?: number
  largeScale?: number
  smallTitleSufix?: string
  largeTitleSufix?: string
}

function FAChart({
  year,
  data,
  title,
  smallRoundPlaces = 2,
  largeRoundPlaces = 0,
  smallScale = 1,
  largeScale = 1,
  smallTitleSufix = '',
  largeTitleSufix = '',
}: FAChartProps) {
  const range = Math.max(...data.map((value) => Math.abs(value)).filter(Number))
  const isLarge = Math.abs(range) >= 1000
  const scale = isLarge ? largeScale : smallScale
  const values = data.map((value) => {
    const rounded = round(scale * value, isLarge ? largeRoundPlaces : smallRoundPlaces)
    return value == null || Number.isNaN(rounded) ? null : rounded
  })

  return (
    <BarChart
      title={title + ' ' + (isLarge ? largeTitleSufix : smallTitleSufix)}
      data={convertData(year, values)}
      valueFormatter={(value) => round(value, isLarge ? largeRoundPlaces : smallRoundPlaces)}
      width={280}
      height={150}
      marginRight={37}
      className="is-fa"
    />
  )
}

interface FundamentalChartsProps {
  index: number
}

export default function FundamentalCharts({ index }: FundamentalChartsProps) {
  const routeData = React.useMemo(
    () =>
      parseRouteInitData<{ year: number; values: Array<number[]> }>({
        elementId: `fa-init-data-${index}`,
        removeElement: false,
      }),
    [index]
  )

  if (!routeData) return null

  return (
    <>
      <td align="center">
        <FAChart title="EPS" year={routeData.year} data={routeData.values[0]} />
      </td>
      <td align="center">
        <FAChart
          title="Sales"
          year={routeData.year}
          data={routeData.values[1]}
          largeRoundPlaces={2}
          largeScale={0.001}
          smallTitleSufix="($mln)"
          largeTitleSufix="($bln)"
        />
      </td>
      <td align="center">
        <FAChart
          title="Shares Outstanding"
          year={routeData.year}
          data={routeData.values[2]}
          largeRoundPlaces={2}
          largeScale={0.001}
          smallTitleSufix="(mln)"
          largeTitleSufix="(bln)"
        />
      </td>
    </>
  )
}
